import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface MediaVoter {
  user_id: string;
  display_name: string;
  avatar_url: string | null;
  voted_at: string;
}

export const useMediaVoters = (mediaId: string | null, isOpen: boolean) => {
  const [voters, setVoters] = useState<MediaVoter[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchVoters = useCallback(async () => {
    if (!mediaId) {
      setVoters([]);
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase.rpc('get_media_voters', {
        p_media_id: mediaId,
      });

      if (error) throw error;
      setVoters((data || []) as MediaVoter[]);
    } catch (error) {
      console.error('Error fetching media voters:', error);
      setVoters([]);
    } finally {
      setLoading(false);
    }
  }, [mediaId]);

  useEffect(() => {
    if (!isOpen || !mediaId) return;

    fetchVoters();

    const channel = supabase
      .channel(`media-voters-${mediaId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'media_votes',
          filter: `media_id=eq.${mediaId}`,
        },
        () => {
          fetchVoters();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [isOpen, mediaId, fetchVoters]);

  return {
    voters,
    loading,
    refetch: fetchVoters,
  };
};
